<style lang="scss" scoped>
  .page-right-part {
    box-sizing: content-box;
    width: 800px;
    padding: 30px 0;
    overflow: auto;

    .title {
      margin-left: 30px;
    }

    .order-info-part {
      padding: 0 50px;
    }

    .goods-info-left {
      width: 330px;
      margin-left: 30px;
      padding: 20px;
      float: left;
      border: 1px solid rgb(238, 238, 238);
      border-top-left-radius: 4px;
      border-bottom-left-radius: 4px;
    }

    .goods-info-right {
      width: 210px;
      padding: 32px 20px 33px 20px;
      background-color: rgb(238, 238, 238);
      border: 1px solid rgb(238, 238, 238);
      float: left;

      .el-row {
        margin-bottom: 5px;
      }

      margin-bottom: 20px;
    }

    .min-gutter {
      .el-form-item {
        margin-bottom: 4px;
      }
    }

    .border-show {
      height: 15px;
      width: 100%;
      border-bottom: 1px solid #777777;
      opacity: 0.2;
      margin-bottom: 10px;
    }

  }

  .exceptionPosition {
    /*margin-left: 40px;*/
    position: absolute;
    right: 0;
    top: 50%;
    transform: translateY(-50%);
  }

  .table {
    .order-list-item {
      color: #999;
      line-height: 20px;
    }

    border-collapse: separate;
    border-spacing: 0;

    > tbody > tr > td {
      border-top: 1px solid #eee;
    }

  }

  .empty-position {
    width: 150px;
    position: absolute;
    left: 50%;
    transform: translateX(-50%);
  }

  .w90 {
    width: 90px;
  }

  .page-right-part {
    width: 750px;
    padding: 0 0 30px 0;
  }

  .base-pic-item {
    border: 1px solid #eee;
    position: relative;
    cursor: pointer;
    width: 180px;
    margin: 5px;
    padding: 10px;
    font-size: 12px;

    img {
      width: 180px;
      height: 180px;
      display: block;
      background: #ccc;

    }

  }

  .margin-left {
    margin-left: 15px;
  }

  .margin-left-right {
    margin-left: 38px;
    margin-right: 38px;
  }

  .power-style-part {
    margin: 12px 0;
    background-color: rgb(238, 238, 238);
    padding: 12px 10px 10px 10px;
  }

  .el-form .el-checkbox__label {
    font-size: 12px;
    padding-left: 5px;
  }

  .el-form .el-checkbox__inner {
    width: 14px;
    height: 14px;
  }

  .margin-bottom {
    margin-bottom: 2px !important;
  }

  .border-show {
    height: 20px;
    border-bottom: 1px solid #777777;
    opacity: 0.2;
    margin-left: 40px;
    margin-right: 40px;
    margin-bottom: 20px;
  }

  .right-title {
    background-color: #b1b1b1;
    height: 30px;
    margin-top: 0;
    margin-bottom: 0;
    padding-left: 20px;
    padding-top: 10px;

  }

  .content-part {
    position: absolute;
    top: 40px;
    bottom: 0;
    left: 0;
    right: 0;
    overflow: auto;

    .content-left {
      width: 120px;
      height: 100%;
      float: left;
      background-color: rgb(238, 238, 238);

      .list-style {
        cursor: pointer;
        padding: 8px 5px 8px 5px;

        &:hover {
          background-color: #ffffff;
        }
      }

      .click-it {
        background-color: #ffffff;
      }
    }

    .content-right {
      width: 510px;
      height: 100%;
      float: left;
      padding-top: 10px;

      .hide-content {
        display: none;
      }

      .show-content {
        display: block;
      }
    }

    .min-gutter {
      .el-form-item {
        margin-bottom: 4px;
      }

      .el-form-item__label {
        font-size: 12px
      }
    }
  }

  .locked {
    border-left: 5px solid #fa0;
    text-indent: -5px;
  }

  .d-table-col-wrap {
    overflow: auto;
  }

  .list-item {
    padding-right: 10px;
  }

</style>
<template>
  <div class="order-page">
    <div class="container">

      <div class="opera-btn-group" :class="{up:!showSearch}">
        <div class="opera-icon">
          <span class="pull-right opera-btn" style="margin-left: 10px">
            <perm label="electron-code-rule-add">
              <span @click.stop="addType">
                   <a href="#" class="btn-circle" @click.prevent="" style="margin-right: 5px"><i
                     class="el-icon-t-plus"></i> </a>添加
              </span>
            </perm>
          </span>
          <!--          <span class="pull-left switching-icon" @click="showSearch = !showSearch">-->
          <!--              <i class="el-icon-arrow-up"></i>-->
          <!--              <span v-show="showSearch">收起筛选</span>-->
          <!--              <span v-show="!showSearch">展开筛选</span>-->
          <!--            </span>-->
        </div>
        <el-form v-show="showSearch" class="advanced-query-form" onsubmit="return false">
          <el-row>
            <el-col :span="10">
              <oms-form-row label="货品" :span="6">
                <el-select placeholder="请输入名称搜索货品" v-model="searchCondition.operateGoodsId" filterable remote
                           :remote-method="queryManageGoods" :clearable="true"
                           popperClass="custom-select">
                  <el-option :label="item.name" :value="item.id" :key="item.id" v-for="item in manageGoods">
                    <manage-goods-option :optionItem="item"/>
                  </el-option>
                </el-select>
              </oms-form-row>
            </el-col>
            <el-col :span="8">
              <oms-form-row label="电子监管码" :span="6">
                <oms-input type="text" v-model="searchCondition.resourceCode" placeholder="电子监管码"></oms-input>
              </oms-form-row>
            </el-col>
            <el-col :span="6">
              <oms-form-row label="" :span="3">
                <el-button type="primary" native-type="submit" @click="searchInOrder">查询</el-button>
                <el-button type="reset" @click="resetSearchForm">重置</el-button>
              </oms-form-row>
            </el-col>
          </el-row>
        </el-form>
      </div>
      <div class="order-list">
        <el-row class="order-list-header">
          <el-col :span="6">货品编号/名称</el-col>
          <el-col :span="6">货品规格</el-col>
          <el-col :span="4">电子监管码</el-col>
          <el-col :span="4">包装层级</el-col>
          <el-col :span="4">操作</el-col>
        </el-row>
        <el-row v-if="loadingData">
          <el-col :span="24">
            <oms-loading :loading="loadingData"></oms-loading>
          </el-col>
        </el-row>
        <el-row v-else-if="!showTypeList.length">
          <el-col :span="24">
            <div class="empty-info">
              暂无信息
            </div>
          </el-col>
        </el-row>
        <div v-else="" class="order-list-body flex-list-dom">
          <div class="order-list-item no-pointer" v-for="item in showTypeList"
               :class="['status-no']">
            <el-row>
              <el-col :span="6">
                <div class="f-grey">{{item.goodsCode}}</div>
                <div>{{item.goodsName}}</div>
              </el-col>
              <el-col :span="6">{{item.specification}}</el-col>
              <el-col :span="4">{{item.resourceCode}}</el-col>
              <el-col :span="4">{{getPackageScheme(item)}}</el-col>
              <el-col :span="4" class="opera-btn">
                <des-btn @click="deleteItem(item)" icon="delete" perm="electron-code-rule-delete">删除</des-btn>
                <des-btn @click="editItem(item)" icon="edit" perm="electron-code-rule-edit">编辑</des-btn>
              </el-col>
            </el-row>
          </div>
        </div>
      </div>
    </div>
    <div class="text-center" v-show="showTypeList.length && !loadingData">
      <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
                     :current-page="pager.currentPage"
                     :page-sizes="[20,50,100]" :page-size="20" layout="total, sizes, prev, pager, next, jumper"
                     :total="pager.count">
      </el-pagination>
    </div>
    <page-right :show="showRight" @right-close="resetRightBox" :css="{'width':'600px'}">
      <edit-form :formItem="form"
                 @right-close="resetRightBox" @change="onSubmit"></edit-form>
    </page-right>
  </div>
</template>
<script>
  import {electronCode} from '@/resources';
  import editForm from './form/form.vue';
  import methodsMixin from '@/mixins/methodsMixin';

  export default {
    mixins: [methodsMixin],
    components: {
      editForm
    },
    data: function () {
      return {
        loadingData: true,
        showRight: false,
        showSearch: true,
        showTypeList: [],
        form: {},
        activeStatus: 0,
        filters: {
          operateGoodsId: '',
          resourceCode: ''
        },
        pager: {
          currentPage: 1,
          count: 0,
          pageSize: 20,
          totalPage: 1
        },
        searchCondition: {
          operateGoodsId: '',
          resourceCode: ''
        }
      };
    },
    mounted() {
      this.queryList(1);
    },
    methods: {
      getPackageScheme: function (item) {
        if (item.packageScheme!=null) {
          return '第' + item.packageScheme + '层级';
        }
        return "";
      },
      deleteItem: function (item) {
        this.$confirm(`确认刪除货品"${item.goodsName}"的电子监管码${item.goodsCode}`, '', {
          confirmButtonText: '确认',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          electronCode.delete(item.id).then(() => {
            this.$notify.success({
              duration: 2000,
              title: '成功',
              message: '刪除成功'
            });
            this.queryList(this.pager.currentPage);
          }).catch(() => {
            this.$notify.error({
              duration: 2000,
              message: '刪除失败'
            });
          });
        }).catch(() => {
        });
      },
      handleSizeChange(val) {
        this.pager.pageSize = val;
        this.queryList(1);
      },
      handleCurrentChange(val) {
        this.queryList(val);
      },
      searchInOrder: function () {// 搜索
        Object.assign(this.filters, this.searchCondition);
        this.queryList(1);
      },
      resetSearchForm: function () {// 重置表单
        let temp = {
          operateGoodsId: '',
          resourceCode: ''
        };
        Object.assign(this.searchCondition, temp);
        Object.assign(this.filters, temp);
        this.queryList(1);
      },
      resetRightBox: function () {
        this.showRight = false;
      },
      addType: function () {
        this.form = {};
        this.showRight = true;
      },
      editItem(item) {
        this.form = Object.assign({}, item);
        this.showRight = true;
      },
      queryList: function (pageNo) {
        this.pager.currentPage = pageNo;
        let params = Object.assign({}, {
          pageNo: pageNo,
          pageSize: this.pager.pageSize
        }, this.filters);
        this.loadingData = true;
        electronCode.query(params).then(res => {
          this.showTypeList = res.data.list;
          this.loadingData = false;
          this.pager.count = res.data.count;
        });
      },
      onSubmit: function () {
        this.queryList(this.pager.currentPage);
      }
    }
  };
</script>
